module.exports = __webpack_public_path__ + "media/images/top/costumes-banner-917cca31d128c0e0c70d3d0fd4d7fb18.jpg";